// "Where was the user trying to go before we bounced them to /sign-in?"
//
// ProtectedRoute stashes the full intended URL (pathname + search) here so
// SignIn can land the user back on it — including `?scholar=…` from the
// marketing landing page — instead of a bare /scholar-path.
//
// sessionStorage (not router state) so the value survives the Google
// OAuth popup round-trip and a page refresh on the code screen.

const KEY = "vg-next";

export const NEXT_LOCATION_KEY = KEY;

/** Only same-origin, path-relative app targets are ever honoured — never
 *  a protocol-relative URL, never the sign-in page itself. */
function isSafe(target: string): boolean {
  if (!target.startsWith("/") || target.startsWith("//") || target.startsWith("/\\")) return false;
  const path = target.split(/[?#]/)[0];
  return path !== "/sign-in" && path !== "/";
}

export function saveNextLocation(pathname: string, search: string): void {
  const target = `${pathname || "/"}${search || ""}`;
  if (!isSafe(target)) return;
  try {
    sessionStorage.setItem(KEY, target);
  } catch {
    /* private mode */
  }
}

/** Forget any saved target (called on sign-out so the next person at a
 *  shared machine isn't sent to the previous user's deep link). */
export function clearNextLocation(): void {
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
}

export function peekNextLocation(): string | null {
  try {
    const v = sessionStorage.getItem(KEY);
    return v && isSafe(v) ? v : null;
  } catch {
    return null;
  }
}

/** Read and clear. Returns null when nothing was saved. */
export function consumeNextLocation(): string | null {
  const v = peekNextLocation();
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
  return v;
}
